import React, { FC, useMemo } from 'react'
import { Button } from '@wmgtech/legato'

import { ArtistAvatar } from 'components'
import { helperInfo } from 'modules/ProjectCreate/constants'
import { ArtistInfo, ProjectCreateContainer, ProjectCreateHelper } from 'modules/ProjectCreate/components'

import { IArtistPreviewProps } from './ArtistPreview.props'
import './ArtistPreview.scss'
import { useFormContext } from 'react-hook-form'

const ArtistPreview: FC<IArtistPreviewProps> = ({ clearArtist, gpsUnits, labelOptions }) => {
  const { getValues } = useFormContext()
  const { gpsStatus, firstCreatedIn, artistName, opusId, facebookId, spotifyId, artistId } = getValues()
  const gpsStatusOption = useMemo(
    () => gpsUnits.find((unit) => unit.value === gpsStatus)?.label || '-',
    [gpsUnits, gpsStatus]
  )

  const artistFoundIn = useMemo(() => {
    return artistId === opusId ? 'GCDM' : 'Storybox'
  }, [artistId, opusId])

  const firstCreatedInLabel = useMemo(() => {
    return artistFoundIn === 'Storybox' ? labelOptions.find((label) => label.value === firstCreatedIn)?.title || '-' : '-'
  }, [labelOptions, firstCreatedIn, artistFoundIn])

  return (
    <ProjectCreateContainer className="artist-preview">
      <div className="artist-preview__section">
        <h3 className="artist-preview__title">Artist found in {artistFoundIn}</h3>
        <section className="artist-preview__description">
          <ArtistAvatar
            className="artist-preview__avatar"
            facebookId={facebookId}
            spotifyId={spotifyId}
            size="s"
            isImage
          />
          <ArtistInfo
            artistName={artistName}
            firstCreatedIn={firstCreatedInLabel}
            gpsStatus={gpsStatusOption}
            opusId={opusId}
          />
        </section>
      </div>
      <div className="artist-preview__section">
        <ProjectCreateHelper>
          <>
            <section>
              <p>{helperInfo.previewArtist}</p>
            </section>
            <section>
              <Button
                label="Clear Selected Artist"
                containerStyle="outline"
                colorType="secondary-black"
                secondaryIcon="user-minus"
                className="artist-preview__btn"
                onClick={clearArtist}
              />
            </section>
          </>
        </ProjectCreateHelper>
      </div>
    </ProjectCreateContainer>
  )
}

export default ArtistPreview
